import { styled } from '@mui/material/styles';
import MaterialPaper from '@mui/material/Paper';

export const Paper = styled(MaterialPaper)(({ theme }) => ({
	'&.MuiPaper-root': {
		padding: theme.spacing(2),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column',
		[theme.breakpoints.down('md')]: {
			//paddingTop: theme.spacing(0),
			//padding: theme.spacing(0),
			//margin: theme.spacing(0),
			//width: '100%',

			//paddingBottom: theme.spacing(0),
			//paddingLeft: theme.spacing(0),
			//paddingRight: theme.spacing(0),
		}
	}
}));

export const BlackPaper = styled(MaterialPaper)(({ theme }) => ({
	'&.MuiPaper-root': {
		background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%, rgba(255, 255, 255, 0.08) 100%), #303030',
	}
}));
